import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dash"
}
const _hoisted_2 = { class: "dash-hero" }
const _hoisted_3 = { class: "dash-hero-text" }
const _hoisted_4 = { class: "dash-title" }
const _hoisted_5 = { class: "dash-sub" }
const _hoisted_6 = { class: "dash-period" }
const _hoisted_7 = {
  class: "dash-segment",
  role: "group",
  "aria-label": "Période"
}
const _hoisted_8 = ["aria-pressed", "onClick"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "dash-range-field" }
const _hoisted_11 = ["max"]
const _hoisted_12 = { class: "dash-range-field" }
const _hoisted_13 = ["min"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  class: "kpi-grid kpi-grid--5",
  "aria-label": "Indicateurs clés"
}
const _hoisted_17 = { class: "kpi-value" }
const _hoisted_18 = { class: "kpi-foot" }
const _hoisted_19 = { class: "kpi-value" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "kpi-foot" }
const _hoisted_22 = { class: "kpi-value" }
const _hoisted_23 = { class: "kpi-foot" }
const _hoisted_24 = { class: "kpi-value" }
const _hoisted_25 = { class: "kpi-value" }
const _hoisted_26 = { class: "dash-section-head" }
const _hoisted_27 = { class: "dash-eyebrow" }
const _hoisted_28 = { class: "dash-section-title" }
const _hoisted_29 = { class: "tile-grid" }
const _hoisted_30 = { class: "tile-text" }
const _hoisted_31 = { class: "tile-value" }
const _hoisted_32 = { class: "tile-label" }
const _hoisted_33 = {
  key: 0,
  class: "ph ph-arrow-up-right tile-go",
  "aria-hidden": "true"
}
const _hoisted_34 = {
  class: "dash-section",
  "aria-label": "Frais de transport"
}
const _hoisted_35 = { class: "dash-section-head" }
const _hoisted_36 = { class: "dash-section-hint" }
const _hoisted_37 = { class: "kpi-grid" }
const _hoisted_38 = { class: "kpi-value" }
const _hoisted_39 = { class: "kpi-foot" }
const _hoisted_40 = { class: "kpi-value" }
const _hoisted_41 = { class: "kpi-foot" }
const _hoisted_42 = { class: "kpi-value" }
const _hoisted_43 = { class: "kpi-foot" }
const _hoisted_44 = { class: "kpi-value" }
const _hoisted_45 = {
  key: 0,
  class: "transport-breakdown"
}
const _hoisted_46 = { class: "transport-name" }
const _hoisted_47 = ["title"]
const _hoisted_48 = { class: "transport-total" }
const _hoisted_49 = {
  key: 1,
  class: "dash-section-hint mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnimatedNumber = _resolveComponent("AnimatedNumber")!
  const _component_ParcelCharts = _resolveComponent("ParcelCharts")!
  const _component_LazyMount = _resolveComponent("LazyMount")!
  const _component_UsersDataChart = _resolveComponent("UsersDataChart")!
  const _component_LastMonthsChart = _resolveComponent("LastMonthsChart")!

  return (_ctx.auth.can('HOME_PAGE'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "dash-eyebrow" }, "Statistiques générales", -1)),
            _createElementVNode("h1", _hoisted_4, "Bonjour" + _toDisplayString(_ctx.firstName ? `, ${_ctx.firstName}` : ""), 1),
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.todayLabel) + " ", 1),
              (_ctx.lastUpdated)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · Mis à jour à " + _toDisplayString(_ctx.lastUpdated), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodOptions, (option) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: option.key,
                  type: "button",
                  class: _normalizeClass(["dash-segment-btn", { active: _ctx.period === option.key }]),
                  "aria-pressed": _ctx.period === option.key,
                  onClick: ($event: any) => (_ctx.setPeriod(option.key))
                }, _toDisplayString(option.label), 11, _hoisted_8))
              }), 128))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["ui-icon-btn dash-refresh", { spinning: _ctx.isLoader }]),
              "aria-label": "Actualiser les statistiques",
              title: "Actualiser",
              disabled: _ctx.isLoader,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshAll && _ctx.refreshAll(...args)))
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("i", {
                class: "ph ph-arrows-clockwise",
                "aria-hidden": "true"
              }, null, -1)
            ]), 10, _hoisted_9)
          ])
        ]),
        _createVNode(_Transition, { name: "dash-slide" }, {
          default: _withCtx(() => [
            (_ctx.period === 'custom')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "dash-range",
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.FilterData && _ctx.FilterData(...args)), ["prevent"]))
                }, [
                  _createElementVNode("label", _hoisted_10, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, "Date début", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchSDate) = $event)),
                      type: "date",
                      class: "form-control",
                      max: _ctx.searchEDate || undefined
                    }, null, 8, _hoisted_11), [
                      [_vModelText, _ctx.searchSDate]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_12, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "Date fin", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchEDate) = $event)),
                      type: "date",
                      class: "form-control",
                      min: _ctx.searchSDate || undefined
                    }, null, 8, _hoisted_13), [
                      [_vModelText, _ctx.searchEDate]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    disabled: _ctx.isLoader
                  }, "Chercher", 8, _hoisted_14),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary",
                    disabled: _ctx.isLoader,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetPeriod && _ctx.resetPeriod(...args)))
                  }, "Annuler", 8, _hoisted_15)
                ], 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("section", _hoisted_16, [
          _createElementVNode("article", {
            class: _normalizeClass(["kpi kpi-featured", { 'is-loading': _ctx.isLoader }])
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "kpi-top" }, [
              _createElementVNode("span", { class: "kpi-label" }, "Total colis"),
              _createElementVNode("span", { class: "kpi-icon" }, [
                _createElementVNode("i", {
                  class: "ph ph-package",
                  "aria-hidden": "true"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_AnimatedNumber, {
                value: _ctx.num(_ctx.dataDash.Totalcolis)
              }, null, 8, ["value"])
            ]),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.periodLabel), 1)
          ], 2),
          _createElementVNode("article", {
            class: _normalizeClass(["kpi kpi-success", { 'is-loading': _ctx.isLoader }])
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "kpi-top" }, [
              _createElementVNode("span", { class: "kpi-label" }, "Colis ramassés"),
              _createElementVNode("span", { class: "kpi-icon" }, [
                _createElementVNode("i", {
                  class: "ph ph-truck",
                  "aria-hidden": "true"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_AnimatedNumber, {
                value: _ctx.num(_ctx.dataDash.TotalRamasse)
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", {
              class: "kpi-progress",
              title: `${_ctx.pickupRate}% des colis ramassés`
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle({ width: _ctx.pickupRate + '%' })
              }, null, 4)
            ], 8, _hoisted_20),
            _createElementVNode("p", _hoisted_21, [
              _createElementVNode("b", null, _toDisplayString(_ctx.pickupRate) + "%", 1),
              _cache[10] || (_cache[10] = _createTextVNode(" des colis ramassés", -1))
            ])
          ], 2),
          _createElementVNode("article", {
            class: _normalizeClass(["kpi kpi-success", { 'is-loading': _ctx.isLoader }])
          }, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "kpi-top" }, [
              _createElementVNode("span", { class: "kpi-label" }, "Colis livrés"),
              _createElementVNode("span", { class: "kpi-icon" }, [
                _createElementVNode("i", {
                  class: "ph ph-package",
                  "aria-hidden": "true"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_AnimatedNumber, {
                value: _ctx.num(_ctx.dataDash.TotalLivres)
              }, null, 8, ["value"])
            ]),
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.periodLabel), 1)
          ], 2),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.canAccessPath('/customers-list') ? 'router-link' : 'article'), {
            to: _ctx.canAccessPath('/customers-list') ? '/customers-list' : undefined,
            class: _normalizeClass(["kpi kpi-info", { 'is-loading': _ctx.isLoader }])
          }, {
            default: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "kpi-top" }, [
                _createElementVNode("span", { class: "kpi-label" }, "Clients"),
                _createElementVNode("span", { class: "kpi-icon" }, [
                  _createElementVNode("i", {
                    class: "ph ph-users-three",
                    "aria-hidden": "true"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_AnimatedNumber, {
                  value: _ctx.num(_ctx.dataDash.Totalclients)
                }, null, 8, ["value"])
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "kpi-foot" }, "Comptes clients", -1))
            ]),
            _: 1,
            __: [13,14]
          }, 8, ["to", "class"])),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.canAccessPath('/users-list') ? 'router-link' : 'article'), {
            to: _ctx.canAccessPath('/users-list') ? '/users-list' : undefined,
            class: _normalizeClass(["kpi", { 'is-loading': _ctx.isLoader }])
          }, {
            default: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "kpi-top" }, [
                _createElementVNode("span", { class: "kpi-label" }, "Utilisateurs"),
                _createElementVNode("span", { class: "kpi-icon" }, [
                  _createElementVNode("i", {
                    class: "ph ph-user-gear",
                    "aria-hidden": "true"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_AnimatedNumber, {
                  value: _ctx.num(_ctx.dataDash.Totalusers)
                }, null, 8, ["value"])
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "kpi-foot" }, "Équipe, livreurs et responsables", -1))
            ]),
            _: 1,
            __: [15,16]
          }, 8, ["to", "class"]))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tileGroups, (group) => {
          return (_openBlock(), _createElementBlock("section", {
            key: group.title,
            class: "dash-section"
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(group.eyebrow), 1),
                _createElementVNode("h2", _hoisted_28, _toDisplayString(group.title), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.tiles, (tile) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(tile.to && _ctx.canAccessPath(tile.to) ? 'router-link' : 'div'), {
                  key: tile.label,
                  to: tile.to && _ctx.canAccessPath(tile.to) ? tile.to : undefined,
                  class: _normalizeClass(["tile", { clickable: tile.to && _ctx.canAccessPath(tile.to), 'is-loading': _ctx.isLoader }])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["tile-icon", `tone-${tile.tone}`])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(tile.icon),
                        "aria-hidden": "true"
                      }, null, 2)
                    ], 2),
                    _createElementVNode("span", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, [
                        _createVNode(_component_AnimatedNumber, {
                          value: _ctx.num(_ctx.dataDash[tile.key])
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(tile.label), 1)
                    ]),
                    (tile.to && _ctx.canAccessPath(tile.to))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))
              }), 128))
            ])
          ]))
        }), 128)),
        _createElementVNode("section", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[17] || (_cache[17] = _createElementVNode("div", null, [
              _createElementVNode("span", { class: "dash-eyebrow" }, "Expéditions"),
              _createElementVNode("h2", { class: "dash-section-title" }, "Frais de transport")
            ], -1)),
            _createElementVNode("span", _hoisted_36, "Bons d'envoi expédiés · " + _toDisplayString(_ctx.periodLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("article", {
              class: _normalizeClass(["kpi kpi-featured", { 'is-loading': _ctx.transportLoading }])
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "kpi-top" }, [
                _createElementVNode("span", { class: "kpi-label" }, "Total frais de transport"),
                _createElementVNode("span", { class: "kpi-icon" }, [
                  _createElementVNode("i", {
                    class: "ph ph-truck-trailer",
                    "aria-hidden": "true"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_AnimatedNumber, {
                  value: _ctx.transportFees.total.fees,
                  decimals: 2
                }, null, 8, ["value"]),
                _createElementVNode("small", null, _toDisplayString(_ctx.$devis), 1)
              ]),
              _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.periodLabel), 1)
            ], 2),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.canAccessPath('/sent-notes') ? 'router-link' : 'article'), {
              to: _ctx.canAccessPath('/sent-notes') ? '/sent-notes' : undefined,
              class: _normalizeClass(["kpi kpi-info", { 'is-loading': _ctx.transportLoading }])
            }, {
              default: _withCtx(() => [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "kpi-top" }, [
                  _createElementVNode("span", { class: "kpi-label" }, "Bons expédiés"),
                  _createElementVNode("span", { class: "kpi-icon" }, [
                    _createElementVNode("i", {
                      class: "ph ph-paper-plane-tilt",
                      "aria-hidden": "true"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_AnimatedNumber, {
                    value: _ctx.transportFees.total.notes
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("p", _hoisted_41, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.transportFees.total.parcels), 1),
                  _cache[19] || (_cache[19] = _createTextVNode(" colis · ", -1)),
                  _createElementVNode("b", null, _toDisplayString(_ctx.transportFees.total.sacs), 1),
                  _cache[20] || (_cache[20] = _createTextVNode(" sacs ", -1))
                ])
              ]),
              _: 1,
              __: [21]
            }, 8, ["to", "class"])),
            _createElementVNode("article", {
              class: _normalizeClass(["kpi kpi-success", { 'is-loading': _ctx.transportLoading }])
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "kpi-top" }, [
                _createElementVNode("span", { class: "kpi-label" }, "Coût moyen par bon"),
                _createElementVNode("span", { class: "kpi-icon" }, [
                  _createElementVNode("i", {
                    class: "ph ph-receipt",
                    "aria-hidden": "true"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_AnimatedNumber, {
                  value: _ctx.transportFees.total.avg_per_note,
                  decimals: 2
                }, null, 8, ["value"]),
                _createElementVNode("small", null, _toDisplayString(_ctx.$devis), 1)
              ]),
              _createElementVNode("p", _hoisted_43, " Sur " + _toDisplayString(_ctx.transportFees.total.notes_with_fees) + " bon(s) avec frais saisis ", 1)
            ], 2),
            _createElementVNode("article", {
              class: _normalizeClass(["kpi", { 'is-loading': _ctx.transportLoading }])
            }, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "kpi-top" }, [
                _createElementVNode("span", { class: "kpi-label" }, "Coût moyen par colis"),
                _createElementVNode("span", { class: "kpi-icon" }, [
                  _createElementVNode("i", {
                    class: "ph ph-package",
                    "aria-hidden": "true"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_AnimatedNumber, {
                  value: _ctx.transportFees.total.avg_per_parcel,
                  decimals: 2
                }, null, 8, ["value"]),
                _createElementVNode("small", null, _toDisplayString(_ctx.$devis), 1)
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "kpi-foot" }, "Frais ÷ colis des bons avec frais", -1))
            ], 2)
          ]),
          (_ctx.transportFees.by_transport.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "transport-row transport-row-head" }, [
                  _createElementVNode("span", null, "Transport"),
                  _createElementVNode("span", null, "Bons"),
                  _createElementVNode("span", null, "Colis"),
                  _createElementVNode("span", null, "Moy. / bon"),
                  _createElementVNode("span", null, "Total")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transportFees.by_transport, (row) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: row.transport_id ?? 'none',
                    class: "transport-row"
                  }, [
                    _createElementVNode("span", _hoisted_46, [
                      _createTextVNode(_toDisplayString(row.transport_name) + " ", 1),
                      _createElementVNode("span", {
                        class: "transport-bar",
                        title: `${_ctx.transportShare(row.fees)}% du total`
                      }, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ width: _ctx.transportShare(row.fees) + '%' })
                        }, null, 4)
                      ], 8, _hoisted_47)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(row.notes), 1),
                    _createElementVNode("span", null, _toDisplayString(row.parcels), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.money(row.avg_per_note)), 1),
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.money(row.fees)), 1)
                  ]))
                }), 128))
              ]))
            : (!_ctx.transportLoading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_49, " Aucun bon d'envoi expédié sur cette période. "))
              : _createCommentVNode("", true)
        ]),
        (_openBlock(), _createElementBlock("section", {
          class: "chart-grid",
          key: `charts-${_ctx.refreshKey}`
        }, [
          _createVNode(_component_LazyMount, null, {
            default: _withCtx(() => [
              _createVNode(_component_ParcelCharts, {
                "period-start": _ctx.searchSDate,
                "period-end": _ctx.searchEDate,
                "period-version": _ctx.periodVersion
              }, null, 8, ["period-start", "period-end", "period-version"])
            ]),
            _: 1
          }),
          _createVNode(_component_LazyMount, null, {
            default: _withCtx(() => [
              _createVNode(_component_UsersDataChart)
            ]),
            _: 1
          })
        ])),
        (_openBlock(), _createBlock(_component_LazyMount, {
          key: `months-${_ctx.refreshKey}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LastMonthsChart)
          ]),
          _: 1
        }))
      ]))
    : _createCommentVNode("", true)
}